// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-multiple-h1',
    standalone: false,
    template: `
        <p translate>H1 on this page</p>

        <ol>
            <li *ngFor="let headline of seo.content; trackBy: trackByIndex">{{ headline }}</li>
        </ol>
    `,
})
export class SeoInformationMultipleH1Component {
    @Input() seo: any;

    trackByIndex (index: number): number {
        return index;
    }
}
